import LockIcon from "@mui/icons-material/Lock";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { TotpMultiFactorGenerator } from "firebase/auth";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { loginHook } from "utils/slide/link/accounts";
import AuthCard from "views/Auth/AuthCard";

const OTP_LENGTH = 6;

export default function MfaAuth(props) {
  const { resolver, setRedirect } = props;

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");

  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, OTP_LENGTH);
    setVerificationCode(digitsOnly);
  };

  const submitCode = () => {
    setLoadingSubmit(true);
    // Ask user for the verification code.
    const multiFactorAssertion = TotpMultiFactorGenerator.assertionForSignIn(
      resolver.hints[0].uid,
      verificationCode,
    );

    // Complete enrollment.
    // Complete sign-in. This will also trigger the Auth state listeners.
    resolver
      .resolveSignIn(multiFactorAssertion)
      .then(function () {
        // userCredential will also contain the user, additionalUserInfo, optional
        // credential (null for email/password) associated with the first factor sign-in.
        // For example, if the user signed in with Google as a first factor,
        // userCredential.additionalUserInfo will contain data related to Google provider that
        // the user signed in with.
        // user.credential contains the Google OAuth credential.
        // user.credential.accessToken contains the Google OAuth access token.
        // user.credential.idToken contains the Google OAuth ID token.
        loginHook();
        setRedirect(true);
      })
      .catch(() => {
        setLoadingSubmit(false);
        enqueueSnackbar("Invalid authentication code. Please try again.", {
          variant: "error",
        });
      });
  };

  return (
    <AuthCard
      header={<LockIcon sx={{ fontSize: "90px", color: "common.white" }} />}
    >
      <Typography variant="h4" sx={{ mb: 2 }}>
        MFA
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {" "}
        Please enter the 6-digit authentication code displayed in your
        authenticator app.
      </Typography>
      <TextField
        label="Confirmation code"
        value={verificationCode}
        onChange={handleChange}
        fullWidth
        autoFocus
        margin="normal"
        slotProps={{
          htmlInput: {
            inputMode: "numeric",
            pattern: "[0-9]*",
            maxLength: OTP_LENGTH,
            autoComplete: "one-time-code",
            style: {
              fontFamily: "monospace",
              fontSize: "1.5rem",
              letterSpacing: "0.5em",
              textAlign: "center",
            },
          },
        }}
      />
      <Box sx={{ pt: 2 }}>
        <Button
          loading={loadingSubmit}
          onClick={submitCode}
          fullWidth
          variant="contained"
          disabled={verificationCode.length < OTP_LENGTH}
        >
          Confirm
        </Button>
      </Box>
    </AuthCard>
  );
}
